import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'common/components/elements/icons';
import ColorPicker from 'common/components/elements/color-picker';
import Input from 'common/components/elements/inputs/inputs';
import './style.scss'
import Button from 'common/components/elements/buttons/primary';
import GenerateColor from 'common/utils/generateTextColor.js'


const CustomizeColor = ({
   color,
   isActive,
   onClick,
   custom,
   // isMobile,
   saveCustomColor,
   className = '',
   itemMargin = 'mx-3',
   disabled,
   tooltipText,
}) => {
   const [showColorPicker, setShowColorPicker] = useState(false)
   const [customColor, setCustomColor] = useState(custom ? color : '')


   function onChangeColor(color) {
      const selectColor  = color && color.hex ? color.hex : color
      setCustomColor(selectColor)

   }
   function onInputChange(name, value) {
      const color = `#${ value }`
      if(value.length >= 7) {
         return
      }
      onChangeColor(color)
   }

   return (
      <>
         <div
            style={ {
               minWidth: '40px',
            } }
            role='presentation'
            onClick={ () => {
               if(disabled) return;

               if(custom) {
                  setShowColorPicker(!showColorPicker)
               } else {
                  onClick(color, custom)
               }
            } }
            className={ cx({
               [`rounded-full w-10 h-10 p-1 flex items-center justify-center ${ itemMargin }`]: true,
               'border-2 border-action': isActive,
               'cursor-pointer': !disabled,
            }) }
            data-tooltip-id={ tooltipText ? 'ams-top-tooltip' : null }
            data-tooltip-content={ tooltipText ? tooltipText : null }
         >
            {
               !custom && (
                  <div
                     className={ `h-full w-full rounded-full ${ className }` }
                     style={ {
                        backgroundColor: color,
                     } }
                  />
               )}
            {
               custom && (
                  <>
                     <div
                        style={ {
                           backgroundColor: customColor,
                        } }
                        className={ cx({
                           'rounded-full flex items-center justify-center h-full w-full': true,
                           'border border-divider': GenerateColor.adaptColor(customColor) !== 'major-dark',
                        })
                        }
                     >
                        <Icon
                           name='pencil'
                           color={ 'major' === GenerateColor.adaptColor(customColor) ? 'secondary' : 'secondary-dark' }
                        />
                     </div>
                  </>
               )
            }
         </div>
         {
            showColorPicker && (

               <div
                  className='flex flex-col absolute z-20 bg-panel customize-color-picker-modal'>
                  <div className='flex flex-col flex-1 px-4 pt-4 pb-1'>
                     <ColorPicker
                        color={ customColor }
                        handleChangeColor={ (color) => onChangeColor(color) }
                     />
                     <div className='relative w-40'>
                        <span className='absolute z-10' style={ {
                           top: '14px',
                           left: '13px',
                        } }>#</span>
                        <Input
                           className='color-input'
                           value={ customColor.replace('#', '') }
                           onChange={ onInputChange }
                        />
                     </div>
                  </div>
                  <div className='flex items-center justify-end h-12 py-4 px-2 bottom-content'>
                     <div className='h-9'>
                        <Button
                           backgroundColor='transparent'
                           text='Cancel'
                           textColor='secondary'
                           textSize='base'
                           classNames='h-full px-3'
                           padding='none'
                           onClick={ () => {
                              setCustomColor(color);
                              setShowColorPicker(false)
                           } }
                        />
                     </div>
                     <div className='h-9 ml-2'>
                        <Button
                           text='Done'
                           textSize='base'
                           classNames='h-full px-3'
                           padding='none'
                           primaryColor
                           borderRadius='large'
                           onClick={ () => {
                              saveCustomColor(customColor);
                              setShowColorPicker(false)
                           } }
                        />
                     </div>
                  </div>
               </div>

            )
         }
      </>
   )
}

CustomizeColor.propTypes = {
   color: PropTypes.string,
   isActive: PropTypes.bool,
   onClick: PropTypes.func,
   saveCustomColor: PropTypes.func,
   custom: PropTypes.bool,
   className: PropTypes.string,
   itemMargin: PropTypes.string,
   disabled: PropTypes.bool,
   tooltipText: PropTypes.string,
}
export default CustomizeColor
